// extracted by mini-css-extract-plugin
module.exports = {"salaryAnalysis":"SalaryAnalysis_salaryAnalysis__1xM1D","externalLink":"SalaryAnalysis_externalLink__2Xdg3"};